import React, { useEffect } from 'react';
import AvisoPrivacidadForm from '../AvisoPrivacidad/AvisoPrivacidadForm';

function FormularioContactoDeck() {
  useEffect(() => {
    // Carga el script de HubSpot
    const script = document.createElement('script');
    script.src = '//js.hsforms.net/forms/embed/v2.js';
    script.type = 'text/javascript';
    script.charset = 'utf-8';
    script.onload = () => {
      // Inicializa el formulario de HubSpot
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: '47654427',
          formId: '9d33c4ae-69c8-45f1-9b02-cf8d3abfdb9f',
          target: '#hubspotForm',
        });
      }
    };
    document.body.appendChild(script);
  }, []);

  return (
    <section id="contacto" className="bg-light"> {/* Agregamos id="contacto" */}
      <div className="container">
        <div className="title-style2 text-center mb-2-2">
          <h2 className="h1">¡Contáctanos para más información del Deck Sintético y una cotización personalizada!</h2>
        </div>
        <div className="row">
          <div 
            className="col-lg-8 mb-5 mb-lg-0 mb-md-5 mx-auto wow fadeIn" 
            data-wow-delay="400ms"
          >
            <div className="contact-form p-4 p-md-5 bg-white rounded">
              <form className="quform">
                {/* Aquí se insertará el formulario de HubSpot */}
                <div id="hubspotForm"></div>
                <AvisoPrivacidadForm />
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FormularioContactoDeck;